import {InputProps, useInput} from '@/hooks/useInput';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shadcn_components/ui/select';
import {ChoiceProps} from '@/hooks/types';
import {Label} from '@/shadcn_components/ui/label';
import {cn} from '@/lib/tailwind-utils';

export type SelectProps = {
  choices?: ChoiceProps[];
  optionValue?: string;
  optionText?: string;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  placeholder?: string;
  emptyOptionText?: string;
} & Partial<React.ComponentProps<'div'>>;

const MySelect = (props: SelectProps) => {
  const {
    choices,
    placeholder,
    optionText = 'label',
    optionValue = 'id',
    className,
    value,
    onChange,
    disabled,
    emptyOptionText,
  } = props;

  const onChangeInternal = (value?:string) => {
    if (value === '<empty>') {
      onChange('');
    }
    else {
      onChange(value);
    }
  };

  return (
    <Select value={String(value)} onValueChange={onChangeInternal} disabled={disabled}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {emptyOptionText!=undefined && (
          <SelectItem value={'<empty>'}>{emptyOptionText}</SelectItem>
        )}
        {(choices || []).map((v, i) => (
          <SelectItem key={i} value={String(v[optionValue])}>
            {v[optionText]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default MySelect;
